import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RedirectToRoot = () => {
  const navigate = useNavigate();
  useEffect(
    () => {
      navigate("/");
    }, // callback function executes onMount/update
    [navigate] // optional dependency array of values which trigger the effect to re-run
  );
  return null; // this is technically the "component"
};

export default RedirectToRoot;
